// @flow

import React from 'react'
import moment from 'moment'
import Path from 'routes/path'
import { ownerName } from 'frontend_core/dist/helpers/format'

export type PropTypes = {
  owner: {
    profileImage: string,
    name: string,
    username: string,
  },
  reputation: {
    description: string,
    replyReputation: string,
    from: {
      name: string,
      profileImage: string,
      username: string,
    },
    reservation: {
      eventType: string,
      eventTypeText: string,
      startedAt: string,
    },
  },
}

export default (props: PropTypes) => {
  const { owner, reputation } = props
  const { description, from, reservation, replyReputation } = reputation
  return (
    <div className="mod-review__line clearfix bd-n">
      <a href={Path.user((from || {}).username)}>
        <img
          src={(from || {}).profileImage}
          alt=""
          className="is-hover mod-review__guest-icon"
        />
      </a>
      <div
        className="mod-review__box-head"
        itemProp="review"
        itemScope
        itemType="http://schema.org/Review"
      >
        <h3
          className="mod-review__guest-name link__subcolor"
          itemProp="author"
          itemScope
          itemType="http://schema.org/Person"
        >
          <a href={Path.user((from || {}).username)}>
            <span itemProp="name">{(from || {}).name}</span>
          </a>
        </h3>
        <ul className="mod-review__list">
          <li>
            {moment(reservation.startedAt).format(
              i18n.t('page.shared.dateFormat3'),
            )}
            {i18n.t('page.review.dateOfUseSuffix')}
          </li>
          <li>
            {i18n.t('page.review.eventType')}
            <a href={Path.eventType(reservation.eventType)}>
              {reservation.eventTypeText}
            </a>
          </li>
        </ul>
      </div>
      <div className="mod-review__box-text">
        <p>{description}</p>
        {replyReputation && (
          <div className="mod-review__res-line clearfix">
            <a href={Path.owner(owner.username)}>
              <img
                src={owner.profileImage}
                alt=""
                className="is-hover mod-review__host-icon"
              />
            </a>
            <div className="mod-review__resbox-head">
              <h4 className="mod-review__host-name link__subcolor">
                <a href={Path.owner(owner.username)}>
                  {ownerName(props.owner)}
                </a>
                {i18n.t('page.room.replyFrom')}
              </h4>
            </div>
            <div className="mod-review__resbox-text">
              <p>{replyReputation}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReputationListItem/index.jsx